<script setup lang="ts">
import { BLink } from 'bootstrap-vue-next';

defineProps<{
  usernames: string[];
}>();
</script>

<template>
  <span>
    <template
      v-for="(username, index) in usernames"
      :key="username"
    >
      <template v-if="index > 0">, </template>
      <BLink :to="{ name: 'user', params: { userHandle: username } }">@{{ username }}</BLink>
    </template>
  </span>
</template>
